import React, { Component, Fragment } from "react";
import * as d3 from "d3";
import $ from "jquery";
import moneyFormatter from "../../common/moneyFormatter";

class GroupStackedBar extends Component {
  state = {
    colors: ["#7ab7e2", "#999999", "#f2b447", "#cf83d4", "#81e07c", "#ccc"],
    label: []
  };
  componentDidMount() {
    this.renderStackChart(this.props);
  }
  componentWillReceiveProps(newProps) {
    // if (
    //   JSON.stringify(this.props.data) !== JSON.stringify(newProps.data) ||
    //   this.props.width !== newProps.width
    // ) {
      $(`#${this.props.id}`).empty();
      this.renderStackChart(newProps);
    // }
  }
  renderStackChart = props => {
    var margin = { top: 20, right: 50, bottom: 40, left: 40 };
    var { width, height, id, lineChartData } = this.props;

    var w = width - margin.left - margin.right,
      h = height - margin.top - margin.bottom;

    var SVG = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", w + margin.left + margin.right)
      .attr("height", h + margin.top + margin.bottom);
    var svg = SVG.append("g").attr(
      "transform",
      "translate(" + margin.left + "," + margin.top + ")"
    );
    var parse = d3.time.format("%Y").parse;

    // Transpose the data into layers
    let arr = Object.keys(props.data[0]).filter((d, i) => d !== "year");

    this.setState({
      label: arr
    });
    var dataset = d3.layout.stack()(
      arr.map(function(el) {
        return props.data.map(function(d) {
          return {
            x: d.year,
            y: el === "returns" ? +d[el] : +d[el],
            title: el
          };
        });
      })
    );
    var x = d3.scale
      .ordinal()
      .domain(
        dataset[0].map(function(d) {
          return d.x;
        })
      )
      .rangeRoundBands([10, w - 10], 0.02);

    var y = d3.scale
      .linear()
      .domain([
        0,
        d3.max(dataset, function(d) {
          return d3.max(d, function(d) {
            return d.y0 + d.y;
          });
        })
      ])
      .range([h, 0]);

    var colors = this.state.colors;
    // "#4779e8"
    // Define and draw axes
    var yAxis = d3.svg
      .axis()
      .scale(y)
      .orient("left")
      .tickSize(-w, 0, 0)
      // .tickFormat(function(d) {
      //   return d;
      // })
      .tickFormat(d3.format("s"));

    var xAxis = d3.svg
      .axis()
      .scale(x)
      .orient("bottom");

    svg
      .append("g")
      .attr("class", "y axis")
      .call(yAxis);

    var outerText = SVG.append("g").attr(
      "transform",
      "translate(" + 5 + "," + margin.top + ")"
    );

    // outerText
    //   .append("text")
    //   .attr("transform", "rotate(-90)")
    //   .attr("x", 10)
    //   .attr("y", 0)
    //   .attr("dy", ".35em")
    //   .style("text-anchor", "end")
    //   .text("Retirement Income Needed");
    // retirement savings

    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + h + ")")
      .call(xAxis)
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-.8em")
      .attr("dy", ".15em")
      .attr("transform", function(d) {
        return "rotate(-65)";
      });
    // Create groups for each series, rects for each segment
    var groups = svg
      .selectAll("g.cost")
      .data(dataset)
      .enter()
      .append("g")
      .attr("class", "cost")
      .style("fill", function(d, i) {
        return colors[i];
      });

    var rect = groups
      .selectAll("rect")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("x", function(d) {
        return x(d.x);
      })
      .attr("y", function(d) {
        return y(d.y0 + d.y);
      })
      .attr("height", function(d) {
        return y(d.y0) - y(d.y0 + d.y);
      })
      .attr("width", x.rangeBand())
      .append("title")
      .text((d, i) => `${d.title} : ${moneyFormatter(d.y)}`);

    //**********line chart***********

    if (lineChartData) {
      var max = d3.max(lineChartData, d => d.Savings);
      var y0 = d3.scale
        .linear()
        .rangeRound([h, 0])
        .domain([0, max]);
      // d3.extent(lineChartData, function(d) {
      //   return d.Savings;
      // })
      var sAxis = d3.svg
        .axis()
        .scale(y0)
        .orient("right")
        .tickSize(-w, 0, 0)
        // .tickFormat(function(d) {
        //   return d;
        // })
        .tickFormat(d3.format("s"));

      svg
        .append("g")
        .attr("transform", "translate(" + w + " ,0)")
        .attr("class", "s_axis")
        .call(sAxis);

      var valueline = d3.svg
        .line()
        .x(d => {
          return x(d.Year);
        })
        .y(d => {
          var yval = y0(d.Savings);
          return yval;
        });

      console.log(lineChartData, "line chart data (stacked barchart) ");
      // adding path
      svg
        .append("g")
        .attr("transform", "translate(" + 20 + " ,0)")
        .append("path")
        .data([lineChartData])
        .attr("class", "stacked_bar_line")
        .attr("d", valueline);

      // outer text
      outerText
        .append("text")
        .attr("text-anchor", "middle") // this makes it easy to centre the text as the transform is applied to the anchor
        .attr("transform", "translate(" + 5 + "," + height / 2 + ")rotate(-90)")
        .text("Retirement Income Needed")
        .style("opacity", ".8");

      outerText
        .append("text")
        .attr("text-anchor", "middle") // this makes it easy to centre the text as the transform is applied to the anchor
        .attr(
          "transform",
          "translate(" + (width - 15) + "," + height / 2 + ")rotate(90)"
        ) // centre below axis
        .text("Retirement Savings")
        .style("opacity", ".8");

      // dots
      svg
        .append("g")
        .attr("transform", "translate(" + 20 + " ,0)")
        .selectAll("dot")
        .data(lineChartData)
        .enter()
        .append("circle")
        .attr("r", 3)
        .attr("cx", function(d) {
          return x(d.Year);
        })
        .attr("cy", function(d) {
          return y0(d.Savings);
        })
        .style("fill", "#565656")
        .style("cursor", "pointer")
        .append("title")
        .text(d => `Savings : ${moneyFormatter(d.Savings)}`);
    }
  };

  render() {
    const { colors, label } = this.state;
    return (
      <Fragment>
        <div id={this.props.id} />
        <div className="table-grid" style={{ marginLeft: "50px" }}>
          {label.map((d, i) => {
            return (
              <div className="table-grid-row" key={d}>
                <div>
                  <span
                    style={{
                      color: `${colors[i]}`,
                      fontSize: "20px",
                      paddingRight: "5px"
                    }}
                  >
                    ●
                  </span>
                  {d}
                </div>
              </div>
            );
          })}
          {this.props.lineChartData ? (
            <div className="table-grid-row">
              <div>
                <span
                  style={{
                    color: "#565656",
                    fontSize: "20px",
                    paddingRight: "5px"
                  }}
                >
                  ....{" "}
                </span>
                Savings Balance
              </div>
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default GroupStackedBar;



// WEBPACK FOOTER //
// ./src/components/d3Components/StackedBarChart/group_stackedBar.jsx